const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect fill='%23f0f0f0' width='400' height='300'/%3E%3Ctext fill='%23999' font-family='sans-serif' font-size='18' text-anchor='middle' x='200' y='155'%3EImagen no disponible%3C/text%3E%3C/svg%3E"

export default PLACEHOLDER_IMAGE
